export default __webpack_public_path__ + "static/media/waffle1.ed60cdbd.png";